module.exports = __webpack_public_path__ + "media/notif3.8d5711eb.wav";